export const MAX_RECENTLY_VIEWED_VEHICLES = 25;

export const merchViewedSavedSearches = 'merchViewedSavedSearches';

export type ViewedSavedSearchItem = {
  cvnaid: string;
  expiration: number;
};
